import { useHeaderNavigateStyles } from "./header-navigate.styles";
import { Link } from "react-router-dom";
import { Badge, Icon } from "@/base/components/index";
import { useContextPageRoot } from "../../context/root-context";
import HeaderNavigateCartSvg from "../../static/header-navigate-cart.svg?react";

export const HeaderNavigateCart = () => {
  const { styles } = useHeaderNavigateStyles();
  const { shoppingCartTotal, localization } = useContextPageRoot();

  return (
    <Badge count={shoppingCartTotal}>
      <Link to={`/${localization.currentLang}/store/cart`}>
        <Icon
          size={24}
          component={HeaderNavigateCartSvg}
          className={styles.cartIcon}
        />
      </Link>
    </Badge>
  );
};
